import { useUserContext } from '../contexts/UserContext';

const mockUser = {
  fullName: 'Demo User',
  email: 'demo.user@gpacs.local',
  role: 'LocalUser',
  siteId: 'SITE-001',
};

export const useUser = () => {
  try {
    const { user, loading, login, logout, fetchUser } = useUserContext();
    const fullName = (user as any)?.displayName || (user as any)?.fullName || user?.username || 'User';
    const email = user?.email || '';
    const role = user?.role || null;
    const siteId = user?.siteId || user?.site_id || null;

    return {
      user,
      loading,
      login,
      logout,
      fetchUser,
      fullName,
      email,
      role,
      siteId,
      canAccessAllSites: Boolean(user?.canAccessAllSites),
    };
  } catch {
    return {
      user: mockUser,
      loading: false,
      login: async () => ({ success: false as const, error: 'Mock mode: login disabled' }),
      logout: () => undefined,
      fetchUser: async () => undefined,
      fullName: mockUser.fullName,
      email: mockUser.email,
      role: mockUser.role,
      siteId: mockUser.siteId,
      canAccessAllSites: false,
    };
  }
};

export default useUser;

